import { render, staticRenderFns } from "./ModalEditConfiguracaoImagem.vue?vue&type=template&id=4c524e34&"
import script from "./ModalEditConfiguracaoImagem.vue?vue&type=script&lang=js&"
export * from "./ModalEditConfiguracaoImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports